import styled from "@emotion/styled";
import { Switch } from "@mui/material";

const IosSwitch = styled((props) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
    width: 42,
    marginRight: "1rem",
    height: 23,
    padding: 0,
    '&.MuiSwitch-sizeSmall': {
        width: 36,
        marginRight: ".5rem",
        height: 18,        
    },
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 2,
        transitionDuration: '300ms',
        '&.Mui-checked': {
            transform: 'translateX(17px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                backgroundColor: theme?.palette?.mode === 'dark' ? '#2ECA45' : '#00B278',
                opacity: 1,
                border: 0,
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.5,
            },
        },
        '&.Mui-focusVisible .MuiSwitch-thumb': {
            color: '#33cf4d',
            border: '6px solid #fff',
        },
        '&.Mui-disabled .MuiSwitch-thumb': {
            color:
                theme?.palette?.mode === 'light'
                    ? theme?.palette?.grey[100]
                    : theme?.palette?.grey[600],
        },
        '&.Mui-disabled + .MuiSwitch-track': {
            opacity: theme?.palette?.mode === 'light' ? 0.7 : 0.3,
        },
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 19,
        height: 19,
    },
    '&.MuiSwitch-sizeSmall .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 14,
        height: 14,
    },
    '& .MuiSwitch-track': {
        borderRadius: 26 / 2,
        backgroundColor: theme?.palette?.mode === 'light' ? '#E9E9EA' : '#39393D',
        opacity: 1,
        transition: theme.transitions?.create(['background-color'], {
            duration: 500,
        }),
    },
}));
export default IosSwitch;